import { Breadcrumb, PageHeader, TenantGateBanner, TenantGateLock, useTenantGate } from "../../components/ui";
import { BenefitPartnerForm } from "../../components/Forms/BenefitPartnerForm";

export const NewBenefitPartner = () => {
  const gate = useTenantGate();

  return (
    <>
      <Breadcrumb
        items={[{ label: "Partners", to: "/benefits-partners" }, { label: "Crear partner" }]}
      />
    <div className="p-card gap-4 p-3">
      <PageHeader title="Crear Partner" />
      <TenantGateBanner action="crear el partner" gate={gate} />
      <TenantGateLock gate={gate}>
        <BenefitPartnerForm />
      </TenantGateLock>
    </div>
    </>
  );
};
